import TextField from "@mui/material/TextField";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

type Props = {};

export const SearchFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";
	const [localValue, setLocalValue] = useState(search);

	// Update local value when URL param changes (e.g., from reset)
	useEffect(() => {
		setLocalValue(search);
	}, [search]);

	// Debounce search param update
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			if (localValue !== search) {
				if (localValue === "") {
					searchParams.delete("search");
				} else {
					searchParams.set("search", localValue);
				}
				setSearchParams(searchParams, { replace: true });
			}
		}, 500);

		return () => clearTimeout(timeoutId);
	}, [localValue, search, searchParams, setSearchParams]);

	const handleFilter = (e: any) => {
		setLocalValue(e.target.value);
	};

	return (
		<div style={{ position: "relative" }}>
			<TextField
				sx={{
					"& .MuiInputBase-input": {
						color: "black",
						paddingRight: "45px",
					},
				}}
				// Label always on the border, like every other filter field
				slotProps={{ inputLabel: { shrink: true } }}
				label="Search"
				variant="outlined"
				size="small"
				value={localValue}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
			/>
			<i
				className="fa fa-search"
				style={{
					position: "absolute",
					right: 17,
					top: 20,
					cursor: "pointer",
				}}
			/>
		</div>
	);
};
